import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {CustomFieldType} from "@/components/business/crud/interface/FieldType";
import {app} from "@/models/App";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

function getShow(node: any, keys: string[]) {
  if (node.children.length > 0) {
    node.children.map((child: any) => getShow(child, keys));
  } else if ((data.value[props.propName] as string[] | undefined)?.some(i => node.id === i)) {
    keys.push(node.id);
  }
}


const tree = ref(app.data.authRule)

const checkedKeys = computed({
  get(): string[] {
    const keys: string[] = [];
    tree.value.map((node: any) => getShow(node, keys));
    console.log(tree)
    return keys;
  },
  set(val: any) {
    if (props.info.status === 'edit') {
      data.value[props.propName] = val;
    }
  },
})


return (_ctx: any,_cache: any) => {
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_tree, {
      checkedKeys: checkedKeys.value,
      "onUpdate:checkedKeys": _cache[0] || (_cache[0] = ($event: any) => ((checkedKeys).value = $event)),
      treeData: tree.value,
      "block-node": true,
      "field-names": { key: 'id' },
      checkable: true
    }, null, 8, ["checkedKeys", "treeData"])
  ]))
}
}

})